// About.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import ProcessFlow from "./ProcessFlow"; // Import ProcessFlow

export default function About() {
  const navigate = useNavigate();

  return (
    <div className="container">
      <h1 className="about-title">About Anonysis</h1>

      <p>
        <strong>Anonysis</strong> is a simple, easy platform designed
        to collect anonymous feedback and leverage AI‐driven analysis
        to help organizations uncover hidden insights. By encouraging candor
        and eliminating the fear of reprisal, Anonysis transforms raw opinions
        into actionable data.
      </p>

      <h2>Our Mission</h2>
      <ul>
        <li>
          <h3>Foster honest dialogue.</h3>
        </li>
        <li>
          <h3>Drive continuous improvement.</h3>
        </li>
        <li>
          <h3>Leverage AI technology.</h3>
        </li>
      </ul>

      <p>
        <strong>Anonysis</strong> isn’t just about gathering feedback—it's about
        <em> sparking transformation</em>. By merging privacy, intelligent
        analytics, and a streamlined user experience, Anonysis paves the way for
        <em> meaningful changes</em> that keep teams engaged, customers loyal,
        and goals in sight.
      </p>

      {/* Wrap ProcessFlow in a div with bottom margin for spacing */}
      <div style={{ marginBottom: "1.5rem" }}>
        <ProcessFlow />
      </div>

      {/* Center the button horizontally with textAlign: center */}
      <div style={{ textAlign: "center" }}>
        <button 
          onClick={() => navigate("/results")}
          className="logout-btn"
          style={{ marginRight: "1rem" }}
        >
          View Results
        </button>

        {/* New "Try It" button */}
        <button
          className="logout-btn"
          onClick={() => navigate("/try-it")}
        >
          Try It
        </button>
      </div>
    </div>
  );
}
